module.exports = __webpack_public_path__ + "img/bgGreen.02954ff5.png";